<template>
  <CfsAutocomplete
    v-bind="$attrs"
    :menu-props="{ contentClass: `cfs-filter-select__list ${selectClass}` }"
    :disabled="disabled"
    :value="selectedFilters"
    class="sm:ml-2 cfs-filter-select"
    :items="computedItems"
    :outlined="outlined"
    chips
    :return-object="returnObject || !objectField"
    :item-text="itemText"
    :item-value="itemValue"
    multiple
    :placeholder="placeholder"
    clear-icon="mdi-close"
    hide-details
    clearable
    @change="$emit('update:selected-filters', $event)"
  >
    <template #selection="{ item, index }">
      <v-chip v-if="index === 0" class="mr-1 max-w-[6.5rem] whitespace-nowrap overflow-hidden">
        <span class="max-w-[5rem] truncate">
          {{ objectField ? item[objectField] : item }}
        </span>
      </v-chip>
      <span v-if="index === 1" class="grey--text text-caption">
        (+{{ selectedFilters.length - 1 }} others)
      </span>
    </template>
    <template v-for="(_, name) in $scopedSlots" #[name]="scope">
      <slot :name="name" v-bind="scope" />
    </template>
  </CfsAutocomplete>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    selectedFilters: {
      type: Array as PropType<string[]>,
      required: true,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: [String, Function],
      default: 'description',
    },
    placeholder: {
      type: String,
      default: '',
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    objectField: {
      type: String,
      default: null,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    constructField: {
      type: Function,
      default: null,
    },
    itemValue: {
      type: String,
      default: 'code',
    },
    selectClass: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const computedItems = computed(() => {
      if (props.constructField && props.itemText) {
        return props.items?.map((item) => {
          return {
            ...item,
            [props.itemText]: props.constructField(item),
          };
        });
      }

      return props.items;
    });

    return { computedItems };
  },
});
</script>

<style lang="scss">
.cfs-filter-select {
  @media (min-width: 600px) {
    max-width: 220px;
  }

  .v-input__slot {
    padding-right: 0 !important;
    padding-left: 15px !important;
  }

  .v-icon.v-icon.v-icon--link {
    font-size: 1rem;
    margin-left: auto;
  }

  &__list .v-list-item__action:first-child {
    margin-right: 12px !important;
  }
}
</style>
